import React, { useState } from "react";
import { FaRegListAlt, FaRegCalendarAlt } from "react-icons/fa";
import moment from "moment";
import PropTypes from "prop-types";
import db from "../../Signin/firebase";
// import { firebase } from "../../Signin/firebase";
import { useSelectedProjectValue } from "../context";
import { ProjectOverlay } from "./ProjectOverlay";
import { TaskDate } from "./TaskDate";
import { useAuth } from "../../Signin/context/AuthContext";
//redux
// import { useSelector, useDispatch } from "react-redux";


// export const AddTask = ({
//   showAddTaskMain = true,
//   shouldShowMain = false,
//   showQuickAddTask,
//   setShowQuickAddTask,
// }) => {
//   const [task, setTask] = useState("");
//   const [taskDate, setTaskDate] = useState("");
//   const [project, setProject] = useState("");
//   const [showMain, setShowMain] = useState(shouldShowMain);
//   const [showProjectOverlay, setShowProjectOverlay] = useState(false);
//   const [showTaskDate, setShowTaskDate] = useState(false);
//   // const { currentUser } = useAuth();
//   const { queryUser, currentUser } = useSelector((state) => state);


//   const { selectedProject } = useSelectedProjectValue();

//   const addTask = () => {
//     const projectId = project || selectedProject;
//     let collatedDate = "";

//     if (projectId === "TODAY") {
//       collatedDate = moment().format("DD/MM/YYYY");
//     } else if (projectId === "NEXT_7") {
//       collatedDate = moment().add(7, "days").format("DD/MM/YYYY");
//     }

//     return (
//       task &&
//       projectId &&
//       db
//         .collection("tasks")
//         .add({
//           archived: false,
//           projectId,
//           task,
//           date: collatedDate || taskDate,
//           userId: currentUser.uid,
//         })
//         .then(() => {
//           setTask("");
//           setProject("");
//           setShowMain("");
//           setShowProjectOverlay(false);
//         })
//     );
//   };

//   return (
//     <div
//       className={showQuickAddTask ? "add-task add-task__overlay" : "add-task"}
//       data-testid="add-task-comp"
//     >
//       {showAddTaskMain && (
//         <div
//           className="add-task__shallow"
//           data-testid="show-main-action"
//           onClick={() => setShowMain(!showMain)}
//           onKeyDown={() => setShowMain(!showMain)}
//           role="button"
//           tabIndex={0}
//         >
//           <span className="add-task__plus">+</span>
//           <span className="add-task__text">Add task</span>
//         </div>
//       )}
//       {(showMain || showQuickAddTask) && (
//         <div className="add-task__main" data-testid="add-task-main">
//           {showQuickAddTask && (
//             <>
//               <div className="" data-testid="quick-add-task">
//                 <h2 className="header">Quick add task</h2>
//                 <span
//                   className="add-task__cancel-x"
//                   data-testid="add-task-quick-cancel"
//                   onClick={() => {
//                     setShowMain(false);
//                     setShowProjectOverlay(false);
//                     setShowQuickAddTask(false);
//                   }}
//                   onKeyDown={() => {
//                     setShowMain(false);
//                     setShowProjectOverlay(false);
//                     setShowQuickAddTask(false);
//                   }}
//                   role="button"
//                   tabIndex={0}
//                 >
//                   X
//                 </span>
//               </div>
//             </>
//           )}
//           <ProjectOverlay
//             setProject={setProject}
//             setShowProjectOverlay={setShowProjectOverlay}
//             showProjectOverlay={showProjectOverlay}
//           />

//           <TaskDate
//             setTaskDate={setTaskDate}
//             showTaskDate={showTaskDate}
//             setShowTaskDate={setShowTaskDate}
//           />

//           <input
//             type="text"
//             className="add-task__content"
//             data-testid="add-task-content"
//             value={task}
//             onChange={(e) => setTask(e.target.value)}
//           />
//           <button
//             type="button"
//             className="add-task__submit"
//             data-testid="add-task"
//             onClick={() =>
//               showQuickAddTask
//                 ? addTask() && setShowQuickAddTask(false)
//                 : addTask()
//             }
//           >
//             Add Task
//           </button>
//           {!showQuickAddTask && (
//             <span
//               className="add-task__cancel"
//               data-testid="add-task-main-cancel"
//               onClick={() => {
//                 setShowMain(false);
//                 setShowProjectOverlay(false);
//               }}
//               onKeyDown={() => {
//                 setShowMain(false);
//                 setShowProjectOverlay(false);
//               }}
//               tabIndex={0}
//               role="button"
//             >
//               Cancel
//             </span>
//           )}
//           <span
//             className="add-task__project"
//             data-testid="show-project-overlay"
//             onClick={() => setShowProjectOverlay(!showProjectOverlay)}
//             onKeyDown={() => setShowProjectOverlay(!showProjectOverlay)}
//             tabIndex={0}
//             role="button"
//           >
//             <FaRegListAlt />
//           </span>
//           <span
//             className="add-task__date"
//             data-testid="show-date-overlay"
//             onClick={() => setShowTaskDate(!showTaskDate)}
//             onKeyDown={() => setShowTaskDate(!showTaskDate)}
//             tabIndex={0}
//             role="button"
//           >
//             <FaRegCalendarAlt />
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

// AddTask.propTypes = {
//   showAddTaskMain: PropTypes.bool,
//   showShouldMain: PropTypes.bool,
//   showQuickAddTask: PropTypes.bool,
//   setShowQuickAddTask: PropTypes.func,
// };

export const AddTask = ({
  showAddTaskMain = true,
  shouldShowMain = false,
  showQuickAddTask,
  setShowQuickAddTask,
}) => {
  const [task, setTask] = useState("");
  const [taskDate, setTaskDate] = useState("");
  const [project, setProject] = useState("");
  const [showMain, setShowMain] = useState(shouldShowMain);
  const [showProjectOverlay, setShowProjectOverlay] = useState(false);
  const [showTaskDate, setShowTaskDate] = useState(false);
  const { currentUser } = useAuth();

  const { selectedProject } = useSelectedProjectValue();

  const addTask = () => {
    const projectId = project || selectedProject;
    let collatedDate = "";

    if (projectId === "TODAY") {
      collatedDate = moment().format("DD/MM/YYYY");
    } else if (projectId === "NEXT_7") {
      collatedDate = moment().add(7, "days").format("DD/MM/YYYY");
    }

    return (
      task &&
      projectId &&
      db
        .collection("tasks")
        .add({
          archived: false,
          projectId,
          task,
          date: collatedDate || taskDate,
          userId: currentUser.uid,
        })
        .then(() => {
          setTask("");
          setProject("");
          setShowMain("");
          setShowProjectOverlay(false);
        })
    );
  };

  return (
    <div
      className={showQuickAddTask ? "add-task add-task__overlay" : "add-task"}
      data-testid="add-task-comp"
    >
      {showAddTaskMain && (
        <div
          className="add-task__shallow"
          data-testid="show-main-action"
          onClick={() => setShowMain(!showMain)}
          onKeyDown={() => setShowMain(!showMain)}
          role="button"
          tabIndex={0}
        >
          <span className="add-task__plus">+</span>
          <span className="add-task__text">Add task</span>
        </div>
      )}
      {(showMain || showQuickAddTask) && (
        <div className="add-task__main" data-testid="add-task-main">
          {showQuickAddTask && (
            <>
              <div className="" data-testid="quick-add-task">
                <h2 className="header">Quick add task</h2>
                <span
                  className="add-task__cancel-x"
                  data-testid="add-task-quick-cancel"
                  onClick={() => {
                    setShowMain(false);
                    setShowProjectOverlay(false);
                    setShowQuickAddTask(false);
                  }}
                  onKeyDown={() => {
                    setShowMain(false);
                    setShowProjectOverlay(false);
                    setShowQuickAddTask(false);
                  }}
                  role="button"
                  tabIndex={0}
                >
                  X
                </span>
              </div>
            </>
          )}
          <ProjectOverlay
            setProject={setProject}
            setShowProjectOverlay={setShowProjectOverlay}
            showProjectOverlay={showProjectOverlay}
          />

          <TaskDate
            setTaskDate={setTaskDate}
            showTaskDate={showTaskDate}
            setShowTaskDate={setShowTaskDate}
          />

          <input
            type="text"
            className="add-task__content"
            data-testid="add-task-content"
            value={task}
            onChange={(e) => setTask(e.target.value)}
          />
          <button
            type="button"
            className="add-task__submit"
            data-testid="add-task"
            onClick={() =>
              showQuickAddTask
                ? addTask() && setShowQuickAddTask(false)
                : addTask()
            }
          >
            Add Task
          </button>
          {!showQuickAddTask && (
            <span
              className="add-task__cancel"
              data-testid="add-task-main-cancel"
              onClick={() => {
                setShowMain(false);
                setShowProjectOverlay(false);
              }}
              onKeyDown={() => {
                setShowMain(false);
                setShowProjectOverlay(false);
              }}
              tabIndex={0}
              role="button"
            >
              Cancel
            </span>
          )}
          <span
            className="add-task__project"
            data-testid="show-project-overlay"
            onClick={() => setShowProjectOverlay(!showProjectOverlay)}
            onKeyDown={() => setShowProjectOverlay(!showProjectOverlay)}
            tabIndex={0}
            role="button"
          >
            <FaRegListAlt />
          </span>
          <span
            className="add-task__date"
            data-testid="show-date-overlay"
            onClick={() => setShowTaskDate(!showTaskDate)}
            onKeyDown={() => setShowTaskDate(!showTaskDate)}
            tabIndex={0}
            role="button"
          >
            <FaRegCalendarAlt />
          </span>
        </div>
      )}
    </div>
  );
};

AddTask.propTypes = {
  showAddTaskMain: PropTypes.bool,
  showShouldMain: PropTypes.bool,
  showQuickAddTask: PropTypes.bool,
  setShowQuickAddTask: PropTypes.func,
};
